module.exports = __webpack_public_path__ + "static/cainallbottlesreverse-c458adf569a39cdb73d5312dad586415.png";